import {createAction} from "redux-actions";
import * as ACTION from "../constants";

export const getListWarehouseStaff = createAction(ACTION.FETCH_LIST_WAREHOUSE_STAFF.REQUEST, (params) => params);
